import { createSlice } from "@reduxjs/toolkit";
import { CategoryPropType } from "./types";

const initialStateValue: CategoryPropType = {
  categories: {
    current_page: 0,
    data: [],
    first_page_url: "",
    from: 0,
    last_page: 0,
    last_page_url: "",
    links: [],
    next_page_url: "",
    path: "",
    per_page: 0,
    prev_page_url: "",
    to: 0,
    total: 0,
  },
  categoriesLoading: true,
};

export const categorySlice = createSlice({
  name: "categories",
  initialState: { value: initialStateValue },
  reducers: {
    setCategory: (state, action) => {
      state.value = { ...state.value, ...action.payload };
    },
  },
});

export const { setCategory } = categorySlice.actions;
export default categorySlice.reducer;
